import React from 'react';
import {
  debitCardCFSB,
  scoreBoostResults,
  ficoShort,
  vantageScoreDisclosure,
  ficoSymbolAlt
} from '@ecs/tng-common/documents/disclosures/regulatory';
import {
  prosConsDisclosure,
  advertiserDisclosure,
  completeInfo
} from '@ecs/tng-common/documents/disclosures/cm-disclosures';
import { DisclosureWithSymbol } from '@ecs/tng-common/components/disclosures/Disclosures';

type FooterDisclosuresProps = {
  boostDisclosure?: boolean;
  vantageScoreDisclosure?: boolean;
};
export default class FooterDisclosures extends React.Component<FooterDisclosuresProps> {
  render() {
    return (
      <>
        <p>
          To view important disclosures about the Experian Smart Money™ Digital Checking Account &
          Debit Card, visit&nbsp;
          <a
            href="https://www.experian.com/legal"
            target="_blank"
            rel="noreferrer">
            experian.com/legal
          </a>
          .
        </p>
        <p>{debitCardCFSB}</p>
        {this.props.vantageScoreDisclosure && (
          <DisclosureWithSymbol disclosure={vantageScoreDisclosure} />
        )}
        {this.props.boostDisclosure && <DisclosureWithSymbol disclosure={scoreBoostResults} />}
        <DisclosureWithSymbol
          disclosure={ficoShort}
          symbol={ficoSymbolAlt}
        />
        <p>
          <strong>Editorial Policy:</strong> The information contained in Ask Experian is for
          educational purposes only and is not legal advice. You should consult your own attorney or
          seek specific advice from a legal professional regarding any legal issues. Please
          understand that Experian policies change over time. Posts reflect Experian policy at the
          time of writing. While maintained for your information, archived posts may not reflect
          current Experian policy.
        </p>
        <p>
          Opinions expressed here are author’s alone, not those of any bank, credit card issuer or
          other company, and have not been reviewed, approved or otherwise endorsed by any of these
          entities, unless sponsorship is explicitly indicated. All information, including rates and
          fees, are accurate as of the date of publication and are updated as provided by our
          partners. Some of the offers on this page may not be available through our website.
        </p>
        <DisclosureWithSymbol
          disclosure={prosConsDisclosure}
          symbol=""
        />
        <p>{advertiserDisclosure}</p>
        <p>{completeInfo}</p>
      </>
    );
  }
}
